import Creation from 'src/components/common/card/creation';
import { useDisclosure } from '@chakra-ui/react';
import is from 'is_js';
import { useState, useContext } from 'react';
import { logger } from 'src/lib/logger';
// import { useFeaturedCollectionMutation } from 'src/app/label/hooks';
import Router, { useRouter } from 'next/router';
import { useArticlePin, useArticlePick } from 'src/app/article/hooks/use-pin';
// import { AddToLabelModal } from 'src/app/label/components/add-to-label-modal';
import { DeleteModal } from 'src/components/modal/delete-modal';
import { useRemoveEpisodeMutation } from 'src/service/project';
import { useRepplEpisodeDeleteMutation } from 'src/app/reppl/hooks';
import { useDeleteCurationMutation } from 'src/app/label/hooks';
import { UserContext, UserContextType } from 'src/contexts/UserContext';
import type { ListType } from 'src/service/creation';

interface Props {
  projectId: string;
  creationType: 'EPISODE' | 'POST';
  data: Array<any>;
  className?: string;
  fns?: Array<string>;
}

const Creations = ({
  projectId,
  creationType,
  data,
  fns = [],
  className = '',
}: Props) => {
  const { user } = useContext(UserContext) as UserContextType;
  // const { toastHandle, setClassName } = useContext(ToastContext) as ToastContextType;

  const { query } = useRouter();
  const { rid, cid } = query;

  const { mutateAsync: createPin } = useArticlePin();
  const { mutateAsync: createPick } = useArticlePick();

  const featureHandel = async (e, type, flag) => {
    const contentID = e.target.getAttribute('data-id');
    setDeletingId(contentID);
    const postData = {
      contentID,
    };
    if (type === 'pinned') {
      postData['pinned'] = flag;
      postData['type'] = 'pin';
      createPin({
        dataset: [postData],
        projectID: projectId,
        contentType: 'EPISODE',
      });
    }
    if (type === 'pick') {
      postData['pick'] = flag;
      postData['type'] = 'pick';
      createPick({
        dataset: [postData],
        projectID: projectId,
        contentType: 'EPISODE',
      });
    }
  };

  const funcitons = {
    edit: {
      name: creationType === 'EPISODE' ? 'Edit episode' : 'edit post',
      fn: (e) => {
        const id = e.target.getAttribute('data-id');
        Router.push(
          creationType === 'EPISODE'
            ? `/reppl/${rid}/episode/${id}/edit`
            : `/username/${id}/edit`
        );
        e.stopPropagation();
      },
    },
    removeEpisode: {
      name: 'Remove episode',
      fn: () => {},
    },
    removePost: {
      name: 'Remove',
      fn: () => {},
    },
    featureFrontPage: {
      name: 'Feature on Home',
      fn: (e) => {
        featureHandel(e, 'pick', true);
      },
    },
    rmFeaturedFrontPage: {
      name: 'Remove on Home',
      fn: (e) => {
        featureHandel(e, 'pick', false);
      },
    },
    pin: {
      name: "Feature in Creator's Picks",
      fn: (e) => {
        featureHandel(e, 'pinned', true);
      },
    },
    rmPinned: {
      name: "Remove in Creator's Picks",
      fn: (e) => {
        featureHandel(e, 'pinned', false);
      },
    },
    // addToCollection: {
    //   name: "Add to collection",
    //   fn: (e) => {
    //     setSelectedArticle(ep);
    //     addToCollectionModal.onOpen();
    //     e.stopPropagation();
    //   },
    // },
  };

  const actions = [];
  if (is.not.empty(fns)) {
    fns.forEach((fnKey, key) => {
      actions.push({
        id: key,
        type: 'click',
        displayName: funcitons[fnKey].name,
        icon: '',
        action: funcitons[fnKey].fn,
      });
    });
  }
  const [selectedArticle, setSelectedArticle] = useState<
    ListType | undefined
  >();
  const deleteModal = useDisclosure();
  const deleteFromCollectionModal = useDisclosure();
  // const addToCollectionModal = useDisclosure();
  const removeEpisodeModal = useDisclosure();
  const { mutateAsync: removeEpisode } = useRemoveEpisodeMutation();
  const { mutateAsync: deleteEpisode } = useRepplEpisodeDeleteMutation();
  const [deletingId, setDeletingId] = useState<string>();
  const {
    mutateAsync: deleteEpisodeFromCollection,
  } = useDeleteCurationMutation();

  return (
    <>
      {data.map((d) => {
        return (
          <Creation
            className={className}
            data={d}
            key={d['contentID']}
            fns={actions}
          />
        );
      })}
      {/* <AddToLabelModal
        key={selectedArticle?.contentID}
        {...addToCollectionModal}
        areaID={projectId}
        areaType={creationType === 'EPISODE' ? 'REPPL' : 'STUDIO'}
        collectionItem={selectedArticle}
        onClose={() => {
          addToCollectionModal.onClose();
          setSelectedArticle(undefined);
        }}
      /> */}
      <DeleteModal
        {...deleteModal}
        onOk={() => {
          if (deletingId) {
            try {
              deleteEpisode(deletingId);
            } catch (err) {
              logger.error(err);
            }
          }
        }}
        title="Are you sure you want to delete this episode?"
        text=""
      />

      <DeleteModal
        {...deleteFromCollectionModal}
        onOk={() => {
          if (cid && deletingId) {
            try {
              deleteEpisodeFromCollection({
                labelID: Number(cid),
                contentID: deletingId,
                contentType: 'EPISODE',
              });
            } catch (err) {
              logger.error(err);
            }
          }
        }}
        title="Are you sure you want to delete this episode from this collection?"
        text=""
      />

      <DeleteModal
        {...removeEpisodeModal}
        title="Remove this episode from the RE:PPL?"
        text={
          user?.username === selectedArticle?.author.username
            ? 'This action cannot be undone. The episode will be moved to your drafts.'
            : 'This action cannot be undone. The episode will be moved to the drafts of the user.'
        }
        okBtnText="Remove"
        onOk={async () => {
          try {
            await removeEpisode({
              spaceID: projectId,
              episodeID: selectedArticle?.contentID,
            });
            setSelectedArticle(undefined);
          } catch (err) {
            logger.error(err);
          }
        }}
        onClose={() => {
          setSelectedArticle(undefined);
          removeEpisodeModal.onClose();
        }}
      />
    </>
  );
};

export default Creations;
